import __vue_component__ from '../HseCheckbox/HseCheckbox.vue.js';

//

/**
 * @figma https://www.figma.com/file/cBHD57QcCt9WDT4e7e2B3w/hse_general_library?node-id=679%3A182
 * @storybook /?path=/story/inputs-radio--radio-group
 * @react /src-components-radio
 * @reactStorybook /?path=/story/inputs-radio--radio-group
 * @requires ./HseRadioGroup.vue
 */
var script = {
  name: 'HseRadio',
  components: {
    HseCheckbox: __vue_component__
  },
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    /**
     * Значение
     */
    modelValue: {
      type: [String, Number],
      default: undefined
    },
    /**
     * @ignore
     */
    value: {
      type: [String, Number],
      default: ''
    },
    /**
     * Лейбл
     */
    label: {
      type: String,
      default: ''
    },
    /**
     * Атрибут name у `input`
     */
    name: {
      type: String,
      default: ''
    },
    /**
     * Неактивное состояние
     */
    inactive: {
      type: Boolean,
      default: false
    },
    /**
     * Сфокусированное состояние
     */
    focused: {
      type: Boolean,
      default: false
    },
    /**
     * Выбранное состояние
     */
    checked: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    isInGroup() {
      return this.$parent.$options.name === 'HseRadioGroup';
    },
    isChecked() {
      return this.checked || this.modelValue === this.value;
    }
  },
  methods: {
    onChange() {
      if (this.inactive) return;
      /**
       * Вызывается при изменении выбранного состояния
       * @type {string | number}
       */
      return this.$emit('change', this.value);
    }
  }
};

export default script;
